module.exports = __webpack_public_path__ + "img/bell.7fc3c438.svg";